import { KILO } from 'constants/metricPrefixes'
import { TerminalLimitsItem } from 'src/schema'
import { div } from 'src/shared/helpers/number'

/**
 * Форматирует число для отображения (заменяет точку на запятую)
 */
const formatNumber = (num: string | number): string => {
  return String(num).replace('.', ',')
}

/**
 * Форматирует лимит терминала для отображения
 */
export const formatTerminalLimit = (limit: TerminalLimitsItem): string => {
  const { code, value } = limit

  switch (code) {
    case 'maxWeight': {
      // Вес в граммах -> килограммы
      const weightInKg = div(value, KILO, 2)
      return `Вес до ${formatNumber(weightInKg)} кг`
    }
    case 'maxHeight': {
      // Высота в сантиметрах
      return `Высота до ${value} см`
    }
    case 'maxWidth': {
      // Ширина в сантиметрах
      return `Ширина до ${value} см`
    }
    case 'maxLength': {
      // Длина в сантиметрах
      return `Длина до ${value} см`
    }
    case 'hasLoader': {
      // Погрузчик (0 или 1, или true/false как число)
      return value ? 'Есть погрузчик' : 'Нет погрузчика'
    }
    case 'hasRamp': {
      // Рампа (0 или 1, или true/false как число)
      return value ? 'Есть рампа' : 'Нет рампы'
    }
    default: {
      // Для неизвестных кодов просто выводим код и значение
      return `${code} ${value}`
    }
  }
}

/**
 * Форматирует массив лимитов терминала для отображения
 */
export const formatTerminalLimits = (limits?: TerminalLimitsItem[]): string[] => {
  if (!limits || limits.length === 0) {
    return []
  }

  return limits.map(formatTerminalLimit)
}
